import {Button, Modal} from '@ds/components';

import {EXTRA_DELIVERY_ACTION_CONTENT} from '../../../constants';

type ExtraDeliveryActionModalProps = {
  state?: string;
  isOpen: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ExtraDeliveryActionModal: React.FC<ExtraDeliveryActionModalProps> = ({
  state,
  isOpen,
  loading,
  onClose,
  onConfirm
}) => {
  const content = state ? EXTRA_DELIVERY_ACTION_CONTENT[state] : undefined;

  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      defaultHeader
      title={content?.modalTitle ?? ''}
      footer={
        <div className="flex justify-between gap-3 border-t border-gray-03 px-4 py-3">
          <Button variant="ghost" color="secondary" onClick={onClose}>
            انصراف
          </Button>
          <Button
            variant="fill"
            color={content?.confirmColor ?? 'secondary'}
            loading={loading}
            onClick={onConfirm}
          >
            {content?.button ?? 'بله'}
          </Button>
        </div>
      }
    >
      <p className="px-4 py-3 text-body-sm text-neutral-fg">{content?.modalDescription}</p>
    </Modal>
  );
};

export default ExtraDeliveryActionModal;
